import { TFunction } from 'language/translator'
import { ENavDestination } from 'types/GlobalUserEvents'

export const getPages = (params: {
  access: {
    entities: boolean
    groups: boolean
    keyMetrics: boolean
    metrics: boolean
    reports: boolean
    tasks: boolean
  }
  t: TFunction
}) => {
  const { access, t } = params

  return [
    // home
    {
      icon: {
        name: 'Home' as const
      },
      title: t('global', 'home'),
      titleLower: t('global', 'home', true),
      to: '/',
      variant: 'page' as const,
      variantTitle: t('global', 'page'),
      destination: ENavDestination.PAGE_HOME
    },
    // key metrics
    ...(access.keyMetrics
      ? [
          {
            icon: {
              name: 'KeyMetrics' as const
            },
            title: t('key_metrics', 'key_metrics'),
            titleLower: t('key_metrics', 'key_metrics', true),
            to: '/key-metrics',
            variant: 'page' as const,
            variantTitle: t('global', 'page'),
            destination: ENavDestination.PAGE_KEY_METRICS
          }
        ]
      : []),
    // tasks
    ...(access.tasks
      ? [
          {
            icon: {
              name: 'Tasks' as const
            },
            title: t('tasks', 'tasks'),
            titleLower: t('tasks', 'tasks', true),
            to: '/tasks',
            variant: 'page' as const,
            variantTitle: t('global', 'page'),
            destination: ENavDestination.PAGE_TASKS
          }
        ]
      : []),
    // groups
    ...(access.groups
      ? [
          {
            icon: {
              name: 'Groups' as const
            },
            title: t('groups', 'all_groups'),
            titleLower: t('groups', 'all_groups', true),
            to: '/groups',
            variant: 'page' as const,
            variantTitle: t('global', 'page'),
            destination: ENavDestination.PAGE_GROUPS
          }
        ]
      : []),
    // dashboards
    {
      icon: {
        name: 'Dashboards' as const
      },
      search: '?type=dashboard',
      title: t('dashboards', 'all_dashboards'),
      titleLower: t('dashboards', 'all_dashboards', true),
      to: '/resources',
      variant: 'page' as const,
      variantTitle: t('global', 'page'),
      destination: ENavDestination.PAGE_DASHBOARDS
    },
    // reports
    ...(access.reports
      ? [
          {
            icon: {
              name: 'Reports' as const
            },
            search: '?type=report',
            title: t('reports', 'all_reports'),
            titleLower: t('reports', 'all_reports', true),
            to: '/resources',
            variant: 'page' as const,
            variantTitle: t('global', 'page'),
            destination: ENavDestination.PAGE_DASHBOARDS
          }
        ]
      : []),
    {
      icon: {
        name: 'Star' as const
      },
      search: '?tab=favorites',
      title: t('global', 'favorites'),
      titleLower: t('global', 'favorites', true),
      to: '/resources',
      variant: 'page' as const,
      variantTitle: t('global', 'page'),
      destination: ENavDestination.PAGE_FAVORITES
    },
    // templates
    {
      icon: {
        name: 'Templates' as const
      },
      title: t('global', 'templates'),
      titleLower: t('global', 'templates', true),
      to: '/templates',
      variant: 'page' as const,
      variantTitle: t('global', 'page'),
      destination: ENavDestination.PAGE_TEMPLATES
    },
    // metrics
    ...(access.metrics
      ? [
          {
            icon: {
              name: 'Metrics' as const
            },
            title: t('metrics', 'all_metrics'),
            titleLower: t('metrics', 'all_metrics', true),
            to: '/metrics',
            variant: 'page' as const,
            variantTitle: t('global', 'page'),
            destination: ENavDestination.PAGE_METRICS
          }
        ]
      : []),
    // entities
    ...(access.entities
      ? [
          {
            icon: {
              name: 'Entities' as const
            },
            title: t('entities', 'entities'),
            titleLower: t('entities', 'entities', true),
            to: '/entities',
            variant: 'page' as const,
            variantTitle: t('global', 'page'),
            destination: ENavDestination.PAGE_ENTITIES
          }
        ]
      : [])
  ]
}
